module.exports = __webpack_public_path__ + "img/data-empty.f3ae6d18.svg";